import { createSelector } from 'reselect';
import { TravellerFieldEnum } from '@websky/graphql';
import { getCustomer } from '../../../../Checkout/store/order/selectors';
import { getUserValue } from '../../../../utils';
import { RefundServicesState } from './types';

interface StateWithRefundServices {
	refundServices: RefundServicesState;
}

export const getRefundServicesState = (state: StateWithRefundServices) => state.refundServices;

export const getRefundServicesSelectedProductIds = createSelector(
	getRefundServicesState,
	refundServices => refundServices.selectedProductIds
);

export const getHasRefundServicesSelectedProducts = createSelector(
	getRefundServicesSelectedProductIds,
	selectedProductIds => selectedProductIds.length > 0
);

export const getRefundServicesLoading = createSelector(
	getRefundServicesState,
	refundServices => refundServices.isLoading
);

export const getRefundServicesModal = createSelector(getRefundServicesState, refundServices => refundServices.modal);

export const getInitialValuesContacts = createSelector(getCustomer, customer => ({
	name: getUserValue(customer, TravellerFieldEnum.FirstName),
	email: getUserValue(customer, TravellerFieldEnum.Email),
	phone: getUserValue(customer, TravellerFieldEnum.Phone),
	comment: ''
}));
